import { useXstreamSelector } from './XstreamProvider'
import { XstreamState } from './XstreamState'

export const useXstreamStore = <TData>(selector: (store: XstreamState) => TData): TData => useXstreamSelector(selector)
